import Dropzone from '@deltablot/dropzone';
Dropzone.autoDiscover = false;

function initFileUploaderComponent(app) {
    app.component('file-uploader', {
        template: '#file-uploader',
        props: {
            id: {required: true},
            uploadUrl: {required: true},
            maxSize: {required: true},
            filesLimit: {default: 1},
            fileLimitReachedError: {default: ''},
            imageSizeLimitError: {default: ''},
            filesExtension: {required: true},
            tooLargeErrorMsg: {required: true},
            smallestSizeMin: {required: true},
            largestSizeMax: {required: true},
            isDragAndDropEnabled: {default: false},
            isActionButton: {default: false},
            hasImage: {default: true},
            changeImageText: {default: ''},
            uploadImageText: {default: ''},
        },
        data() {
            return {
                uploadInProgressFilesNumber: 0,
                uploader: {},
                inProgress: false,
            };
        },
        watch: {
            inProgress(val) {
                if (val) {
                    this.$emit('upload-started');
                } else {
                    this.$emit('upload-completed');
                }
            },
        },
        mounted() {
            this.uploader = this.initUploader();
        },
        methods: {
            initUploader() {
                const instance = this;
                return new Dropzone(`#${this.id}`, {
                    url: this.uploadUrl,
                    acceptedFiles: this.filesExtension,
                    parallelUploads: 3,
                    paramName: 'file',
                    maxFilesize: this.maxSize, // MB
                    dictFileTooBig: this.tooLargeErrorMsg,
                    thumbnailWidth: 300,
                    thumbnailHeight: 180,
                    addRemoveLinks: true,
                    autoProcessQueue: true,
                    uploadMultiple: true,
                    timeout: Number.MAX_VALUE,

                    error(file, errorMessage) {
                        const errorMessageElement = file.previewElement.querySelector('.dz-error-message');
                        errorMessage = errorMessage.replace('{filesize}', instance.formatBytesToMb(file.size));
                        errorMessageElement.innerText = errorMessage;
                        instance.handleError(errorMessage);
                    },

                    accept(file, done) {
                        file.acceptDimensions = () => {
                            if (instance.filesLimit - instance.uploadInProgressFilesNumber > 0) {
                                instance.uploadInProgressFilesNumber++;
                                done();
                            } else {
                                done(instance.fileLimitReachedError);
                            }
                        };
                        file.rejectDimensions = () => {
                            done(instance.imageSizeLimitError);
                        };
                    },

                    thumbnail(file, dataUrl) {
                        if (file.acceptDimensions && file.rejectDimensions) {
                            const minDim = Math.min(file.width, file.height);
                            const maxDim = Math.min(file.width, file.height);
                            if (minDim >= instance.smallestSizeMin && maxDim >= instance.largestSizeMax) {
                                file.acceptDimensions();
                            } else {
                                file.rejectDimensions();
                            }
                        }

                        const previewElement = file.previewElement.querySelector('.dz-image img');
                        previewElement.setAttribute('src', dataUrl);
                    },

                    success(file, response) {
                        const dzInstance = this;
                        const onUpload = (photo) => {
                            dzInstance.removeFile(file);
                            instance.uploadInProgressFilesNumber--;
                            instance.$emit('uploaded', photo);
                        };

                        setTimeout(() => onUpload(response), 100);
                    },

                    totaluploadprogress: (progress) => {
                        if (instance.uploader.uploadProgress) {
                            instance.uploader.uploadProgress(progress);
                        }
                    },

                    uploadprogress() {
                        instance.inProgress = true;
                    },

                    queuecomplete() {
                        instance.inProgress = false;
                    },

                    removedFile() {
                        instance.uploadInProgressFilesNumber--;
                    },

                    canceled: () => {
                        instance.uploadInProgressFilesNumber--;
                    },
                });
            },

            handleError(errorMessage) {
                console.error(errorMessage);
            },

            formatBytesToMb(bytes) {
                const bytesInMb = Math.pow(1024, 2);
                return parseFloat((bytes / bytesInMb).toFixed(2));
            },
        },
        computed: {
            uploadButtonText() {
                return this.hasImage ? this.changeImageText : this.uploadImageText;
            },
        },
    });
}

export default initFileUploaderComponent;
